module.exports = __webpack_public_path__ + "static/media/noun-upload-document-1316856-142350.3e271e73.svg";